var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import EnumSelect from 'components/EnumSelect';
var FocusRequestSelect = function (props) { return (_jsx(EnumSelect, __assign({ enum_name: "FOCUS_REQUEST_TYPE" }, props))); };
export default FocusRequestSelect;
